import React, { useEffect } from 'react';
import { Modal, Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClientProcedure, fetchClientProcedureFilter, clientProcedureClear, clientProcedureFilterClear } from 'app/actions/ClientProcedureActions';
import { getClientProcedure, getClientProcedureFilter, getIsLoadingClientProcedure } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import isEmpty from 'app/utils/IsEmpty';

export default function ClientProcedureTableContainer(props) {
    const { classes } = props;
    const { confirm } = Modal;

    const { siteId } = useSelector(state => state.Auth);

    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const columns = [
        {
            title: 'Clasificación',
            dataIndex: 'procedureName',
            key: 'procedureName',
            sorter: true,
            width: 300,
            ellipsis: true

        },
        {
            title: 'Compañía',
            dataIndex: 'clientName',
            key: 'clientName',
            sorter: true,
            width: 300,
            ellipsis: true

        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idProcedure',
            fixed: 'right',
            width: 120,
            render: (text, record) => (
                <div className={classes.buttons}>

                    {
                        siteId === 'HUB' ?
                            <Tooltip placement="bottomLeft" title={'Eliminar'}>
                                <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(record)}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>
                            :
                            null
                    }

                    <Tooltip placement="bottomLeft" title={siteId === 'HUB' ? 'Editar' : 'Visualizar'}>
                        <IconButton className={classes.editIcon} onClick={() => showEdit(record)}>
                            {
                                siteId === 'HUB' ?
                                    <Icon type="edit" />
                                    :
                                    <Icon type="eye" />
                            }
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    const showEdit = (param) => {
        props.isVisibleForm(true);
        props.setIdProcedure(param.idProcedure);
        props.setNameProcedure(param.procedureName);
        props.setIdClient(String(param.idClient));
    }

    const showConfirmDelete = (param) => {
        confirm({
            title: '¿Eliminar Clasificación?',
            content: param.ProcedureName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                props.setFiltroClasificacion(props.FiltroClasificacion.filter(x => x !== param.procedureName));
                props.setFiltroCompany(props.FiltroCompany.filter(x => x !== param.clientName));
                return deleteClientProcedure(param);
            },
            onCancel() { },
        });

    }

    async function deleteClientProcedure(param) {
        await ApiService.deleteProcedure(param.idProcedure).then(res => {
            dispatch(clientProcedureClear());
            dispatch(clientProcedureFilterClear());
            dispatch(fetchClientProcedureFilter({ IdProcedureType: '1' }))
            dispatch(fetchClientProcedure({
                procedureName: props.FiltroClasificacion.filter(x => x !== param.procedureName).join(','),
                clientName: props.FiltroCompany.filter(x => x !== param.clientName).join(','),
                IdProcedureType: '1',
                sortColumn: column,
                sortDir: order, offset: offset, limit: limit
            }));

            const modal = Modal.success({
                title: `Eliminado Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    let clientProcedure = useSelector(getClientProcedure);
    let clientProcedureFilter = useSelector(getClientProcedureFilter);

    let isLoading = useSelector(getIsLoadingClientProcedure);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(clientProcedure)) fetchClientProcedureAction();
        if (isEmpty(clientProcedureFilter)) fetchClientProcedureFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        dispatch(fetchClientProcedure(
            {
                procedureName: props.FiltroClasificacion.join('|'),
                clientName: props.FiltroCompany.join('|'),
                // CommunicationProgramName: (props.formData.CommunicationProgramName === undefined) ? '' : props.formData.CommunicationProgramName,
                // CommunicationProgramDescription: (props.formData.CommunicationProgramDescription === undefined) ? '' : props.formData.CommunicationProgramDescription,
                IdProcedureType: '1',
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && clientProcedure.length > 0) {
            pagination.total = clientProcedure[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }



    const fetchClientProcedureAction = () => dispatch(fetchClientProcedure({
        sortColumn: column,
        procedureName: props.FiltroClasificacion !== undefined ? props.FiltroClasificacion.join(',') : '',
        clientName: props.FiltroCompany !== undefined ? props.FiltroCompany.join(',') : '',
        IdProcedureType: '1',
        sortDir: order, offset: offset, limit: limit
    }));
    const fetchClientProcedureFilterAction = () => dispatch(fetchClientProcedureFilter({ IdProcedureType: '1' }))
    return (props.children({ pagination: pagination, cols: columns, clientProcedure, clientProcedureFilter, isLoading, handleTableChange: handleTableChange }));
}

